import moment from "moment";

const formatDuration = (startTime) => {
  const diff = moment().diff(moment.utc(startTime));
  const dur = moment.duration(diff);

  let parts = [];

  if (dur.asSeconds() < 60) {
    const seconds = Math.floor(dur.asSeconds());
    parts.push(`${seconds} second${seconds !== 1 ? "s" : ""}`);
  } else if (dur.asMinutes() < 60) {
    const minutes = Math.floor(dur.asMinutes());
    const seconds = dur.seconds();
    if (minutes > 0) parts.push(`${minutes} minute${minutes !== 1 ? "s" : ""}`);
    if (seconds > 0) parts.push(`${seconds} second${seconds !== 1 ? "s" : ""}`);
  } else if (dur.asHours() < 24) {
    const hours = Math.floor(dur.asHours());
    const minutes = dur.minutes();
    const seconds = dur.seconds();
    if (hours > 0) parts.push(`${hours} hour${hours !== 1 ? "s" : ""}`);
    if (minutes > 0) parts.push(`${minutes} minute${minutes !== 1 ? "s" : ""}`);
    if (seconds > 0) parts.push(`${seconds} second${seconds !== 1 ? "s" : ""}`);
  } else {
    const days = Math.floor(dur.asDays());
    const hours = dur.hours();
    const minutes = dur.minutes();
    if (days > 0) parts.push(`${days} day${days !== 1 ? "s" : ""}`);
    if (hours > 0) parts.push(`${hours} hour${hours !== 1 ? "s" : ""}`);
    if (minutes > 0) parts.push(`${minutes} minute${minutes !== 1 ? "s" : ""}`);
  }

  return parts.join(" ");
}

export default formatDuration;
